import Icon from '../../../components/AppIcon';

const ServiceAreaMap = () => {
  const serviceAreas = [
    {
      area: "Central Business District",
      responseTime: "20-30 minutes",
      coverage: "Full coverage"
    },
    {
      area: "Northern Suburbs",
      responseTime: "30-40 minutes",
      coverage: "Full coverage"
    },
    {
      area: "Southern Suburbs",
      responseTime: "30-40 minutes",
      coverage: "Full coverage"
    },
    {
      area: "Eastern Suburbs",
      responseTime: "35-45 minutes",
      coverage: "Full coverage"
    },
    {
      area: "Western Suburbs",
      responseTime: "35-45 minutes",
      coverage: "Full coverage"
    },
    {
      area: "Surrounding Areas",
      responseTime: "45-60 minutes",
      coverage: "Selected areas"
    }
  ];

  return (
    <div className="bg-card rounded-lg p-6 md:p-8 shadow-sm border border-border">
      <div className="mb-6">
        <h2 className="font-headline font-bold text-xl md:text-2xl lg:text-3xl mb-2">
          Service Area Coverage
        </h2>
        <p className="font-body text-sm md:text-base text-muted-foreground">
          We provide reliable service across the greater region with fast response times
        </p>
      </div>
      <div className="bg-muted rounded-lg overflow-hidden mb-6" style={{ height: '300px' }}>
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="meriodine Service Area"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=-26.2041,28.0473&z=11&output=embed"
          className="border-0"
        />
      </div>
      <div className="space-y-3 md:space-y-4">
        <h3 className="font-headline font-semibold text-lg md:text-xl mb-3 md:mb-4">
          Response Times by Area:
        </h3>

        <div className="grid grid-cols-1 gap-3 md:gap-4">
          {serviceAreas?.map((area, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Icon name="MapPin" size={20} className="flex-shrink-0 text-primary" />
                <div className="flex-1 min-w-0">
                  <h4 className="font-headline font-semibold text-sm md:text-base">
                    {area?.area}
                  </h4>
                  <p className="font-body text-xs md:text-sm text-muted-foreground">
                    {area?.coverage}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <Icon name="Clock" size={16} className="text-accent" />
                <span className="font-accent text-xs md:text-sm font-semibold text-accent whitespace-nowrap">
                  {area?.responseTime}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-start gap-3 bg-primary/10 rounded-lg p-4">
          <Icon name="Info" size={20} className="flex-shrink-0 text-primary mt-1" />
          <div className="flex-1 min-w-0">
            <p className="font-body text-sm md:text-base text-foreground">
              Response times are estimates based on normal traffic conditions. Emergency calls receive priority dispatch.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaMap;